/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extracting_AudioInputs */

const en_extracting_audio = /** @type {(inputs: Extracting_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracting audio...`)
};

const fr_extracting_audio = /** @type {(inputs: Extracting_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction audio...`)
};

const de_extracting_audio = /** @type {(inputs: Extracting_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio wird extrahiert...`)
};

const it_extracting_audio = /** @type {(inputs: Extracting_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrazione audio...`)
};

const ru_extracting_audio = /** @type {(inputs: Extracting_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извлечение аудио...`)
};

const es_extracting_audio = /** @type {(inputs: Extracting_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrayendo audio...`)
};

const zh_cn2_extracting_audio = /** @type {(inputs: Extracting_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在提取音频...`)
};

const ja_extracting_audio = /** @type {(inputs: Extracting_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声を抽出しています...`)
};

const hi_extracting_audio = /** @type {(inputs: Extracting_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो निकाला जा रहा है...`)
};

const pt_pt2_extracting_audio = /** @type {(inputs: Extracting_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraindo áudio...`)
};

/**
* | output |
* | --- |
* | "Extracting audio..." |
*
* @param {Extracting_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const extracting_audio = /** @type {((inputs?: Extracting_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extracting_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_extracting_audio(inputs)
	if (locale === "de") return de_extracting_audio(inputs)
	if (locale === "it") return it_extracting_audio(inputs)
	if (locale === "ru") return ru_extracting_audio(inputs)
	if (locale === "es") return es_extracting_audio(inputs)
	if (locale === "zh-CN") return zh_cn2_extracting_audio(inputs)
	if (locale === "ja") return ja_extracting_audio(inputs)
	if (locale === "hi") return hi_extracting_audio(inputs)
	if (locale === "pt-PT") return pt_pt2_extracting_audio(inputs)
	return en_extracting_audio(inputs)
});